import React from 'react';
import { render } from 'react-dom';

import CookiesNotice from '../react/CookiesNotice';

export default class CookiesNoticeRender {
  constructor(context) {
    this.context = context;
    this.init();
  }

  init() {
    const { model } = this.context.dataset;
    if (!model) throw Error('Missing a required dataset');
    const jsonModel = JSON.parse(model);

    render(<CookiesNotice {...jsonModel} />, this.context);
  }
}
